import { render, staticRenderFns } from "./PaymentAmount.vue?vue&type=template&id=781cc4ae"
import script from "./PaymentAmount.vue?vue&type=script&lang=ts"
export * from "./PaymentAmount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports